import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ScreenPagePart from "../../components/login/screenpage";
import RecoverPasswordForm from "../../components/login/recover";
import NewPasswordForm from "../../components/login/newPassword";
import ErrorPage from "../error";

const NewPasswordPage = () => {

  const url = window.location.href;

  // Создание объекта URL
  const urlParams = new URLSearchParams(new URL(url).search);

  // Извлечение значения параметра 'token'
  const token = urlParams.get("token");

  if (!token) {
    return <ErrorPage code={403} message="Не найден токен восстановления" />;
  }

  return (
    <ScreenPagePart>
      <div className="inner centerItem">
        <NewPasswordForm token={token} />
      </div>
    </ScreenPagePart>
  );
};

export default NewPasswordPage;